import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=b168bce4&scoped=true&"
import script from "./ToolBar.vue?vue&type=script&lang=js&"
export * from "./ToolBar.vue?vue&type=script&lang=js&"
import style0 from "./ToolBar.vue?vue&type=style&index=0&id=b168bce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b168bce4",
  null
  
)

export default component.exports